import React, {Component} from 'react';
import _HauteFire from '../Utils/HauteFire';
const HauteFire = new _HauteFire();

export default class Compose extends Component {
    constructor() {
        super();

        this.state = {objMail: {}}
    }

    sendMail(e) {
        e.preventDefault();

        let {objMail} = this.state;
        objMail.id = Date.now();
        objMail.isSent = false;

        HauteFire.addUpdate(objMail.id, objMail, "IslandDeals");

        return false;
    }

    render() {
        return (
            <div id="mailbox-content" className="mailbox-content">
                <div id="compose-view" className="compose-view">
                    <form className="form-horizontal form-email-compose" onSubmit={() => {
                        return false;
                    }}
                          action="return false;">
                        <div className="control-group">
                            <input type="email" placeholder="To"
                                   className="input-transparent form-control" onInput={(e) => {
                                const islandOwner = e.currentTarget.value.trim();
                                if (islandOwner != "") {
                                    let {objMail} = this.state;
                                    objMail.islandOwner = islandOwner;

                                    this.setState({objMail});
                                }
                            }}/>
                        </div>
                        <div className="control-group">
                            <input type="text" placeholder="Subject"
                                   className="input-transparent form-control" onInput={(e) => {
                                const subject = e.currentTarget.value.trim();
                                if (subject != "") {
                                    let {objMail} = this.state;
                                    objMail.subject = subject;

                                    this.setState({objMail});
                                }
                            }}/>
                        </div>
                        <div className="control-group">
                            <ul className="wysihtml5-toolbar">
                                <li className="dropdown">
                                    <a className="btn btn-sm btn-transparent dropdown-toggle" data-toggle="dropdown"
                                       href="#">
                                        <i className="fa fa-font"></i>
                                        &nbsp;<span className="current-font">Normal text</span>
                                        &nbsp;&nbsp;
                                        <i className="fa fa-caret-down"></i>
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <a data-wysihtml5-command="formatBlock" data-wysihtml5-command-value="div"
                                               href="javascript:;" unselectable="on">Normal text</a>
                                        </li>
                                        <li>
                                            <a data-wysihtml5-command="formatBlock" data-wysihtml5-command-value="p"
                                               href="javascript:;" unselectable="on">Normal text</a>
                                        </li>
                                        <li>
                                            <a data-wysihtml5-command="formatInline" data-wysihtml5-command-value="span"
                                               href="javascript:;" unselectable="on">Normal text</a>
                                        </li>
                                        <li>
                                            <a data-wysihtml5-command="formatBlock" data-wysihtml5-command-value="h1"
                                               href="javascript:;" unselectable="on">Heading 1</a>
                                        </li>
                                        <li>
                                            <a data-wysihtml5-command="formatBlock" data-wysihtml5-command-value="h2"
                                               href="javascript:;" unselectable="on">Heading 2</a>
                                        </li>
                                        <li>
                                            <a data-wysihtml5-command="formatBlock" data-wysihtml5-command-value="h3"
                                               href="javascript:;" unselectable="on">Heading 3</a>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <div className="btn-group">
                                        <a className="btn btn-sm btn-transparent " data-wysihtml5-command="bold"
                                           title="CTRL+B" href="javascript:;" unselectable="on"><i
                                            className="fa fa-bold"></i></a>
                                        <a className="btn btn-sm btn-transparent " data-wysihtml5-command="italic"
                                           title="CTRL+I" href="javascript:;" unselectable="on"><i
                                            className="fa fa-italic"></i></a>
                                    </div>
                                </li>
                                <li>
                                    <div className="btn-group">
                                        <a className="btn btn-sm btn-transparent "
                                           data-wysihtml5-command="insertUnorderedList" title="Unordered list"
                                           href="javascript:;" unselectable="on"><i className="fa fa-list"></i></a>
                                        <a className="btn btn-sm btn-transparent "
                                           data-wysihtml5-command="insertOrderedList" title="Ordered list"
                                           href="javascript:;" unselectable="on"><i className="fa fa-th-list"></i></a>
                                        <a className="btn btn-sm btn-transparent " data-wysihtml5-command="Outdent"
                                           title="Outdent" href="javascript:;" unselectable="on"><i
                                            className="fa fa-outdent"></i></a>
                                        <a className="btn btn-sm btn-transparent " data-wysihtml5-command="Indent"
                                           title="Indent" href="javascript:;" unselectable="on"><i
                                            className="fa fa-indent"></i></a>
                                    </div>
                                </li>
                                <li>
                                    <div className="btn-group">
                                        <a className="btn btn-sm btn-transparent " data-wysihtml5-action="change_view"
                                           title="Edit HTML" href="javascript:;" unselectable="on"><i
                                            className="fa fa-pencil"></i></a>
                                    </div>
                                </li>
                                <li>
                                    <div className="bootstrap-wysihtml5-insert-link-modal modal hide fade">
                                        <div className="modal-header">
                                            <a className="close" data-dismiss="modal">×</a>
                                            <h3>Insert link</h3>
                                        </div>
                                        <div className="modal-body">
                                            <input value="http://"
                                                   className="bootstrap-wysihtml5-insert-link-url input-xlarge"/>
                                        </div>
                                        <div className="modal-footer">
                                            <a href="#" className="btn" data-dismiss="modal">Cancel</a>
                                            <a href="#" className="btn btn-primary" data-dismiss="modal">Insert link</a>
                                        </div>
                                    </div>
                                    <a className="btn btn-sm btn-transparent " data-wysihtml5-command="createLink"
                                       title="Insert link" href="javascript:;" unselectable="on"><i
                                        className="fa fa-share"></i></a>
                                </li>
                                <li>
                                    <div className="bootstrap-wysihtml5-insert-image-modal modal hide fade">
                                        <div className="modal-header">
                                            <a className="close" data-dismiss="modal">×</a>
                                            <h3>Insert image</h3>
                                        </div>
                                        <div className="modal-body">
                                            <input value="http://"
                                                   className="bootstrap-wysihtml5-insert-image-url input-xlarge"/>
                                        </div>
                                        <div className="modal-footer">
                                            <a href="#" className="btn" data-dismiss="modal">Cancel</a>
                                            <a href="#" className="btn btn-primary" data-dismiss="modal">Insert
                                                image</a>
                                        </div>
                                    </div>
                                    <a className="btn btn-sm btn-transparent " data-wysihtml5-command="insertImage"
                                       title="Insert image" href="javascript:;" unselectable="on"><i
                                        className="fa fa-picture-o"></i></a>
                                </li>
                            </ul>
                            <textarea rows="12" className="input-transparent" style={{width: '100%'}} onInput={(e) => {
                                const message = e.currentTarget.value.trim();
                                if (message != "") {
                                    let {objMail} = this.state;
                                    objMail.message = message;

                                    this.setState({objMail});
                                }
                            }}></textarea>

                        </div>
                        <div className="control-group">
                            <div className="fileupload-buttonbar">
                                                        <span className="btn btn-sm btn-transparent fileinput-button">
                                                            <i className="fa fa-paper-clip"></i>
                                                            Attach files...
                                                            <input type="file" name="files[]" multiple=""/>
                                                        </span>
                            </div>
                            <table role="presentation" className="table table-striped no-margin">
                                <tbody className="files"></tbody>
                            </table>
                        </div>
                        <div className="control-group">
                            <button className="btn btn-sm btn-primary"
                                    onClick={this.sendMail.bind(this)}>&nbsp;&nbsp;&nbsp;Send&nbsp;&nbsp;&nbsp;</button>
                            <button type="button" id="compose-save-button"
                                    className="btn btn-sm btn-transparent">&nbsp;&nbsp;Save&nbsp;&nbsp;</button>
                            <button type="reset" id="compose-discard-button" className="btn btn-sm btn-transparent">
                                Discard
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/TestPage/Compose.js